import { render, staticRenderFns } from "./EditPrinter.vue?vue&type=template&id=2d4a7a7a&scoped=true&"
import script from "./EditPrinter.vue?vue&type=script&lang=js&"
export * from "./EditPrinter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4a7a7a",
  null
  
)

export default component.exports